/**
 * Created by asiulik on 29.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter',
    './filterConfig',
    './filterContent',
    './filterHeader',
    './filterTags',
    './filterPreloader',
    '../../core/page/pageHistory'
], function($, _, EventEmitter, FilterConfig, FilterContent, FilterHeader, FilterTag, FilterPreloader, HistoryM){

    function Filter($element){
        this.$element = $element;
        this.history = new HistoryM();
    }

    Filter.prototype = _.clone(EventEmitter.prototype);

    Filter.prototype.init = function(){

        this.$filterShowMoreItems = this.$element.find(FilterConfig.filterLoadMoreSelector);

        this.initModules();
        this.bindEvents();

    };

    Filter.prototype.initModules = function(){

        this.filterHeader = new FilterHeader(
            this.$element.find(FilterConfig.defaultFilterHeaderSelector)
        );

        this.filterContent = new FilterContent(
            this.$element.find(FilterConfig.defaultFilterContentSelector)
        );

        this.filterPreloader = new FilterPreloader(
            this.$element.find(FilterConfig.filterPreloaderSelector)
        );

        this.filterHeader.init();
        this.filterContent.init();

    };

    Filter.prototype.bindEvents = function(){

        var _this = this;

        this.filterHeader.on('filter:header:tagChange', function(tagName, url){

            _this.$element.addClass('filters--pending');

            _this.filterPreloader.showPreloader();
            _this.filterHeader.setDisabledState(true);

            _this.getFilterData(url).then(function(response) {

                _this.$filterShowMoreItems.show();

                _this.filterContent.replaceContentWithAnimation(
                    $(response).find(FilterConfig.defaultFilterContentSelector)
                );

                _this.filterHeader.setDisabledState(false);
                _this.filterPreloader.hidePreloader();

                _this.$element.removeClass('filters--pending');

                _this.history.updateHistory(url);

            });

        });

        this.filterContent.on('filter:content:contentChanged', function(currentCollection) {
            _this.emit('filter:content:contentChanged', currentCollection);
        });

        this.filterContent.on('filter:content:allVisible', function(currentCollection) {

            _this.$filterShowMoreItems.hide();

        });

        this.$filterShowMoreItems.on('click', function(){

            _this.filterContent.showMoreContent();

        });

    };

    Filter.prototype.getFilterData = function (url) {

        var _this = this;
        var dfd = jQuery.Deferred();

        $.get(url).then(function(data){

            setTimeout(function(){
                return dfd.resolve($(data).find(FilterConfig.filtersSelector));
            }, 1000)

        });

        return dfd.promise();

    };

    return Filter;

});


// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filter.js